export default __webpack_public_path__ + "static/media/kitchen3-afterF-1920w.69f24a78.webp";